/* eslint-disable */
// import jwtInterceptor from "../Shared/jwtInterceptor";
import axios from 'axios';
import store from "../../store/index";
import NestedJsonTable from "../../custom_lib/nestedjsontotable.vue";
import raiseQueryModal from "../raiseQueryModal/raiseQueryModal.vue"
export default {
    name: 'FHIRpage',
    props: {
        subjectCode: {
            type: String,
            required: true,
        },
        siteCode: {
            type: String,
            required: true,
        },
        visitName:{
          type:String,
          default:""
        },
        siteId:{
          type:String,
          default:""
        },
        subjectId:{
          type:String,
          default:""
        },
    },
    components: {
        NestedJsonTable,
        raiseQueryModal
      },
    data() {
        return {
            baseapi: process.env.VUE_APP_Service_URL,
            deviceArray:[],
            FHIRpatient: {},
            fromPage:"",
            openRaiseQuery:false,
            fieldname:""
        }
    },
    async mounted() {        
      if(sessionStorage.getItem("previousRouteName")=='submitForm' || sessionStorage.getItem("previousRouteName")=='subject_schedule'){
        this.FHIRpatient=JSON.parse(sessionStorage.getItem('FHIRpatient'))
      }
      else{
        await this.getFHIRtoken();
        await this.ListFHIRPatient();
      }
       this.fieldname = this.FHIRpatient.code.text;
       console.log("lets assume field name is ",this.fieldname);
    },
    beforeRouteEnter(to, from, next) {
      // Save previous route name to sessionStorage (optional)
      if (from.name) {
        sessionStorage.setItem('previousRouteName', from.name);
      }
  
      next((vm) => {
        // Try to get from actual `from` or from sessionStorage fallback
        const previousRoute = from.name || sessionStorage.getItem('previousRouteName');
        vm.previousRouteName = previousRoute;
      });
    },
  
    beforeRouteLeave(to, from, next) {
      sessionStorage.removeItem('previousRouteName');
      next();
    },
    methods: {
      async onclosed() {
        if(sessionStorage.getItem("previousRouteName")=='submitForm'){
          this.$router.push("/submitForm")
        }
        else if(sessionStorage.getItem("previousRouteName")=='subject_schedule'){
          this.$router.push("/subject_schedule")
        }
        else{
          this.$router.push(`/patientList`);
        }
       
      },
      async getFHIRtoken() {
          const idtoken = store.getters.getIdToken;
          await axios
            .get(`${this.baseapi}/management/fhir/access-token`, {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            })
            .then((res) => {
              this.idtoken = res.data;
            })
            .catch((err) => {
              console.log(err);
            });
        },      
      async ListFHIRPatient() {
        await axios
          .get(`https://ids-ctms.fhir.azurehealthcareapis.com/Patient?identifier=${this.subjectCode}&siteCode=${this.siteCode}`, {
            headers: {
              Authorization: "Bearer " + this.idtoken,
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            
            this.FHIRpatient = res.data.entry[0].resource;
            console.log(this.FHIRpatient, "This is FHIR List");
          })
          .catch((err) => {
            console.log(err);
          });
      },
        
    }
}